import Vue from 'vue'
import Vuex from 'vuex'

import { State as DState, Mutations as DMutations, Actions as DActions } from './stock_detail'
import { State as FState, Mutations as FMutations, Actions as FActions } from './future_date'
import { State as UState, Mutations as UMutations, Actions as UActions } from './user_info'
import { State as HState, Mutations as HMutations, Actions as HActions } from './hide_navigate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...DState,
    ...FState,
    ...UState,
    ...HState

  },
  mutations: {
    ...DMutations,
    ...FMutations,
    ...UMutations,
    ...HMutations
  },
  actions: {
    ...DActions,
    ...FActions,
    ...UActions,
    ...HActions
  },
  modules: {}
})
